import { useGuideStore } from "./useGuideStore";

export const isGuideSupported = (guideTitle: string) => {
    const { availableGuides } = useGuideStore.getState();
    const isGuideSupported = !!availableGuides?.find((guide) => [guideTitle].includes(guide.title));
    return isGuideSupported;
};
